import { ApiLandingPagePlaylist, ApiPlaylist } from '@storefronts/common-types'
import React from 'react'

export type StorefrontPlaylist = ApiLandingPagePlaylist | ApiPlaylist

type FullScreenVideoCtx = {
    currentIdx: number
    setCurrentIdx: React.Dispatch<React.SetStateAction<number>>
    currentPlaylist: StorefrontPlaylist | null
    setCurrentPlaylist: React.Dispatch<
        React.SetStateAction<StorefrontPlaylist | null>
    >
    isFullScreenPlayerOpen: boolean
    setIsFullScreenPlayerOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const DefaultFullScreenVideoContext: FullScreenVideoCtx = {
    currentIdx: -1,
    setCurrentIdx: () => {},
    currentPlaylist: null,
    setCurrentPlaylist: () => {},
    isFullScreenPlayerOpen: false,
    setIsFullScreenPlayerOpen: () => {},
}

export const FullScreenVideoContext = React.createContext(
    DefaultFullScreenVideoContext,
)
